import { ApplicationConfig, InjectionToken, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from '@angular/router';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { routes } from './app.routes';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';
import { HammerModule } from '@angular/platform-browser';
import { provideNativeDateAdapter } from '@angular/material/core';
import { PCPS_DIALOGS_DEFAULT_OPTIONS, PCPSDialogsDefaultOptions, ScreenSizeService } from '@polk_county_public_schools/ngx-pcps-dialogs/core';
import {
    PCPS_SNACK_BAR_DEFAULT_OPTIONS,
    PCPSSnackBarDefaultOptions,
    SnackBarModule,
} from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { ConfirmationDialogService } from '@polk_county_public_schools/ngx-pcps-dialogs/confirmation';
import { MessageBoxDialogService } from '@polk_county_public_schools/ngx-pcps-dialogs/messagebox';
import { CountdownDialogService } from '@polk_county_public_schools/ngx-pcps-dialogs/countdown';

export function getBaseUrl(): string {
    return document.getElementsByTagName('base')[0].href;
}

export const BASE_URL = new InjectionToken<string>('BASE_URL');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' }),
            withViewTransitions()
        ),
        { provide: BASE_URL, useFactory: getBaseUrl, deps: [] },
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(HammerModule, SnackBarModule, BrowserAnimationsModule),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ separator: ':', caseSensitive: true }),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideAnimations(),
        {
            provide: PCPS_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: {
                invertBackground: true,
            } as PCPSSnackBarDefaultOptions,
        },
        {
            provide: PCPS_DIALOGS_DEFAULT_OPTIONS,
            useValue: {
                useClassicCancel: true,
            } as PCPSDialogsDefaultOptions,
        },
        ScreenSizeService,
        //need these here because they are used in authService,
        //which can't have it's own providers list
        //and these services are not providedIn: 'root' in their code
        //so need to provide them in root in this file
        ConfirmationDialogService,
        MessageBoxDialogService,
        CountdownDialogService,
        provideNativeDateAdapter(),
    ],
};
